export const colors = {
    stroke: "#BEC0C3",
    lightTextColor: "#414243",
    textColor: "#28292B",
    bgMenu: "#F9FBFF",
    lightGray: "#EBEEF5",
    bluishGray: "#D5DFEB",
    white: "#FFFFFF",
    activeVideFrame: "#EB1330",
};

export const variables = {
    headerHeight: "8.1rem",
    sideBarWidth: "9.2rem",
};
